import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledCheckbox } from 'components/shared';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { BuhHandlingSelect } from './components/BuhHandlingSelect';
import NominalCalculationValues from './components/NominalCalculationValues';
import NonProductiveHours from './components/NonProductiveHours';
import SurchargesBonusSection from './components/SurchargesBonusSection';

import FormSubSection from '../../FormSubSection';
import { useAgeHoursDependingOnDynFlag } from './hooks/useAgeHoursDependingOnDynFlag';
import { GridCompact12 } from 'components/shared/Grid/Grid.components';

const SurchargesSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', { keyPrefix: 'employerCostSettings' });

  useAgeHoursDependingOnDynFlag();

  return (
    <MultiStepForm.Section title={t('details.surcharges.title')}>
      <FormSubSection title={t('title')}>
        <GridCompact12>
          <BuhHandlingSelect />
        </GridCompact12>
        <GridCompact12>
          <ControlledCheckbox
            disabled
            control={control}
            label={t('details.surcharges.salary_over_nph_label')}
            name="flags.FIN_SAL_OVER_NPH"
          />
        </GridCompact12>
        <GridCompact12>
          <ControlledCheckbox
            control={control}
            label={t('details.surcharges.age_hours_dyn_label')}
            name="flags.COST_AGE_HOUR_CALC"
          />
        </GridCompact12>
      </FormSubSection>

      <FormSubSection
        title={t('details.surcharges.non_productive_hours_separator_label')}
      >
        <NonProductiveHours />
      </FormSubSection>

      <FormSubSection
        title={t('details.surcharges.surcharges_bonus_separator_label')}
      >
        <SurchargesBonusSection />
      </FormSubSection>

      <FormSubSection
        title={t('details.surcharges.nominal_calculation_separator_label')}
      >
        <NominalCalculationValues />
      </FormSubSection>
    </MultiStepForm.Section>
  );
};

export default SurchargesSection;
